import axios from "axios";
import { camelizeKeys, decamelizeKeys } from "humps";

const axiosObj = axios.create({
  baseURL: process.env.REACT_APP_BASE_API_URL,
  timeout: 5000,
  withCredentials: true,
});

// intercept response - convert to camelCase
axiosObj.interceptors.response.use(
  (response) => {
    if (
      response.data &&
      response.headers["content-type"] === "application/json"
    ) {
      response.data = camelizeKeys(response.data);
    }
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// intercept request - convert all params/data to snake_case
axiosObj.interceptors.request.use(
  (config) => {
    if (config.headers["Content-Type"] === "multipart/form-data") return config;
    if (config.params) {
      config.params = decamelizeKeys(config.params);
    }
    if (config.data) {
      config.data = decamelizeKeys(config.data);
    }
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

export default axiosObj;
